import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CaseInformation from "../../views/subview/CaseLogView";
import EmailsView from "../../views/subview/EmailsView";
import DocumentView from "../../views/subview/DocumentView";
import RegistrationView from "../../views/subview/ShipmentRegister";
import { fetchShipmentsByThreadId } from "../../store/features/shipmentsSlice";

const TabSection = ({ threadId }) => {
  const [activeTab, setActiveTab] = useState("Case Overview");
  const dispatch = useDispatch();
  const { shipments, status } = useSelector((state) => state.shipments);
  // Fetch shipments when the threadId changes
  useEffect(() => {
    if (threadId & status === "idle") {
      dispatch(fetchShipmentsByThreadId(threadId));
    }
  }, [dispatch, threadId]);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  const Registered = shipment?.CI

  // Render content based on the active tab
  const renderTabContent = () => {
    switch (activeTab) {
      case "Case Overview":
        return <CaseInformation threadId={threadId} />;
      case "Emails":
        return <EmailsView threadId={threadId} />;
      case "Documents":
        return <DocumentView threadId={threadId} />;
      case "Shipment Registration":
        return <RegistrationView threadId={threadId}/>;
      default:
        return null;
    }
  };
  // Define the tabs dynamically based on the `registered` prop
  const tabs = Registered
    ? ["Case Overview", "Emails", "Documents"] // Exclude "Shipment Registration"
    : ["Case Overview", "Emails", "Documents", "Shipment Registration"]; // Include all tabs

  return (
    <div>
      {/* Tabs */}
      <div className="flex  border-black">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`py-1 px-6 text-md text-font-LIGHT border-x border-t border-black rounded-t-md ${
              activeTab === tab
                ? "bg-logo border border-logo font-bold text-white" // Active tab styles
                : "bg-white text-gray-500 hover:bg-[#F7F7F7] hover:text-font" // Inactive tab styles
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="p-4 border border-black rounded-b-lg rounded-tr-md bg-white mt-0 shadow-sm">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default TabSection;
